import React, { useState } from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';

var SectionWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  &:last-child { margin-bottom: 0; }
`;

var SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;

  &:hover {
    border-color: #d9d9d9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

var SectionIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${function(p) { return p.bg || '#f0f5ff'; }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .anticon, svg {
    font-size: 16px;
    color: ${function(p) { return p.color || '#1890ff'; }};
  }
`;

var SectionInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

var SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #262626;
`;

var SectionDescription = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 1px;
`;

var ChevronIcon = styled.div`
  color: #bfbfbf;
  font-size: 12px;
  transition: transform 0.2s;
  transform: rotate(${function(p) { return p.open ? '0deg' : '-90deg'; }});
`;

var SectionBody = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.2s ease, margin 0.2s ease;
  max-height: ${function(p) { return p.open ? '2000px' : '0'; }};
  opacity: ${function(p) { return p.open ? 1 : 0; }};
  margin-top: 0;
`;

var CollapsibleSection = function(props) {
  var defaultOpen = props.defaultOpen !== false;
  var openState = useState(defaultOpen);
  var isOpen = openState[0];
  var setIsOpen = openState[1];

  var toggle = function() {
    setIsOpen(!isOpen);
  };

  var headerStyle = isOpen ? { borderRadius: '8px 8px 0 0', borderBottom: 'none' } : {};

  return React.createElement(SectionWrapper, null,
    React.createElement(SectionHeader, { onClick: toggle, style: headerStyle },
      React.createElement(SectionIcon, { bg: props.bg, color: props.color },
        props.icon
      ),
      React.createElement(SectionInfo, null,
        React.createElement(SectionTitle, null, props.title),
        props.description && React.createElement(SectionDescription, null, props.description)
      ),
      React.createElement(ChevronIcon, { open: isOpen },
        React.createElement(Icon, { type: 'down' })
      )
    ),
    React.createElement(SectionBody, { open: isOpen },
      props.children
    )
  );
};

export default CollapsibleSection;
